import { VStack } from '@terra/ui-styled-system';
import { Skeleton } from '../../components/styled/skeleton';

export type SettingsListSkeletonProps = {
  count?: number;
  itemHeight?: string;
};

export function SettingsListSkeleton({
  count = 3,
  itemHeight = '122px',
}: SettingsListSkeletonProps) {
  return (
    <VStack alignItems="stretch" gap={4} w="full">
      {Array.from({ length: count }, (_, index) => (
        <Skeleton key={index} h={itemHeight} />
      ))}
    </VStack>
  );
}
